export const isUnauthorizedApiResponse = (response, payload) =>
  response?.status === 401 || payload?.resultCode === 401;

export const forceLogoutToLogin = () => {
  if (typeof window === "undefined") {
    return;
  }

  try {
    window.localStorage.removeItem("persist:mrt-speciallane");
  } catch (_) {
    // ignore storage access issues
  }

  if (window.location.pathname !== "/login") {
    window.location.replace("/login");
  }
};
